module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( "noresults" === context ) { 
__p+=' <h4>'+
((__t=( i18n.tc( "Empty", "No results found" ) ))==null?'':__t)+
'</h4><p>'+
((__t=( i18n.tc( "Empty", "We're terribly sorry, but we couldn't find any search results." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "noinstalled" === context ) { 
__p+=' <h4>'+
((__t=( i18n.tc( "Empty", "No results found" ) ))==null?'':__t)+
'</h4><p>'+
((__t=( i18n.tc( "Empty", "Could not find any installed devices associated with this account." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "supportserp" === context ) { 
__p+=' <p>'+
((__t=( i18n.tc("SupportResponseEmpty", "No results found.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "replace" === context ) { 
__p+=' <p>'+
((__t=( i18n.tc( "Empty", "Unfortunately there are no other subscription packages available for your device." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "no:applications" === context ) { 
__p+=' <p>'+
((__t=( i18n.tc( "Empty", "There are currently no applications." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "no:invitations" === context ) { 
__p+=' <p class="no-notifications">'+
((__t=( i18n.tc( "Empty", "Unfortunately there are no invitations available." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "notifications" === context ) { 
__p+=' <p class="no-notifications">'+
((__t=( i18n.tc( "Empty", "— You have no unread notifications." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "allnotifications" === context ) { 
__p+=' <p class="no-notifications">'+
((__t=( i18n.tc( "Empty", "— You have no notifications." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "noweather" === context ) { 
__p+=' <p class="no-notifications">'+
((__t=( i18n.tc( "Empty", "— No weatherdata available." ) ))==null?'':__t)+
'</p> ';
 } 
__p+='';
}
return __p;
};
